import React, { useState, useEffect } from "react";
import { getUserData } from "../../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import { CheckGeoConfigAccess } from "../../../services/GeoLocationApi";
import GeoLocationAllStoreViewMap from "./GeoLocationAllStoreViewMap";
 
export default function GeoLocationAllStoreView() {
  const navigate = useNavigate();

  const { brandProfileData } = getUserData();
  
  let brandCode = brandProfileData.brandCode;

  const [viewMap, setViewMap] = useState(false);
  const [resAPIKey, setResAPIKey] = useState("");

  useEffect(() => {
    const data = {
      brandCode: brandCode,
      accessCount: 0
    };

    CheckGeoConfigAccess(data)
      .then((response) => {
        
        const ResStatus = response.data.status;
      const ResAPIKey = response.data.apiKey;

        if(ResStatus === "success") {
          setViewMap(ResStatus);
          setResAPIKey(ResAPIKey)
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
       
      {viewMap ? (
        <GeoLocationAllStoreViewMap resAPIKey={resAPIKey} />
      ) : (
       <div className="flex flex-column h-full">
          {/* Header */}
          <div
            className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
            style={{ "--surface-0": "#1752AA" }}
          >
            <div className="flex-1 flex ml-3 mr-3">
              <div className="flex-1 flex">
                <div className="ml-3 flex justify-content-center align-items-center">
                  <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                    <i
                      className="pi pi-angle-left"
                      onClick={() => navigate("/StoreManagementList")}
                      style={{
                        fontSize: "27px",
                        cursor: "pointer",
                        color: "#fff",
                      }}
                    ></i>
                  </div>
                </div>
                <div className="flex-1 ml-5">
                  <p className="text-2xl text-white font-bold uppercase">
                    Geo Location
                  </p>
                </div>
              </div>
               
            </div>
          </div>
          <div className="flex justify-content-center mt-5">
            <p className="text-3xl font-bold capitalize">
              Your Account is Low Balance, Please Recharge Geo Location Account
              For Further Usage.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
